export default "__VITE_ASSET__CALnaaGj__"